import { useEffect, useState } from "react";

export type AppMode = "media" | "betting";

const KEY = "ss2026_mode";
const EVT = "ss2026:mode";
const HIDDEN_PARAM = "betting-demo";

export function getMode(): AppMode {
  if (typeof window === "undefined") return "media";
  // Hidden activation: only via URL ?mode=betting-demo
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("mode") === HIDDEN_PARAM) return "betting";
  } catch {
    /* noop */
  }
  // Public default is always media; internal override via localStorage only when explicitly set to betting
  const stored = localStorage.getItem(KEY) as AppMode | null;
  return stored === "betting" ? "betting" : "media";
}

export function setMode(m: AppMode) {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY, m);
  window.dispatchEvent(new CustomEvent(EVT, { detail: m }));
}

export function isBettingDemoUrl(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return new URLSearchParams(window.location.search).get("mode") === HIDDEN_PARAM;
  } catch {
    return false;
  }
}

export function useMode(): [AppMode, (m: AppMode) => void] {
  const [mode, set] = useState<AppMode>("media");
  useEffect(() => {
    set(getMode());
    const handler = (e: Event) => {
      const ce = e as CustomEvent<AppMode>;
      set(ce.detail);
    };
    window.addEventListener(EVT, handler);
    return () => window.removeEventListener(EVT, handler);
  }, []);
  return [mode, setMode];
}